import { createStyles } from '@svg/antd/es/theme/utils'

export default createStyles(({ css }) => {
  return css`
        & {
          padding: 2px;
          width: fit-content;
          height: auto;
          border-radius: 10px;
          background: #FFFFFF;
          box-shadow: 0px 5px 24px 0px #00000028;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          box-shadow: 0px 5px 24px 0px #00000028;
          .quick-box {
            visibility: hidden;
            opacity: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all 0.3s;
            width: 0px;
            span {
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .quick-btn {
              display: flex;
            }
            .divider {
              width: 1px;
              height: 8px;
              background-color: rgba(0, 0, 0, 0.08);
              margin-left: 3.5px;
            }
          }
          &.show-quick {
            &:hover {
              .quick-box {
                visibility: visible;
                opacity: 1;
                width: 24px;
              }
            }
          }
        }
    `
});
